// extracted by mini-css-extract-plugin
export default {"entityNameCell":"GridEntityNameCell_entityNameCell__RQbbd","entityIcon":"GridEntityNameCell_entityIcon__MlGkI"};